import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'pxw-cart-order-item-option-group',
  templateUrl: './cart-order-item-option-group.component.html',
  styleUrls: ['./cart-order-item-option-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.cart-order-item-option-group--readonly]': 'readOnly()',
  },
})
export class CartOrderItemOptionGroupComponent {
  readonly name = input<string | undefined>(undefined);
  readonly readOnly = input(false);
}
